export default {
  "nav.spreadsheet": "CSSBuy Spreadsheet",
  "nav.categories": "Categorias",
  "nav.guides": "Guias",
  "nav.reviews": "Reviews",
  "nav.shipping": "Envio",
  "nav.qc": "QC",
  "nav.safety": "Segurança",
  "nav.faq": "FAQ",
  "nav.about": "Sobre",
  "nav.contact": "Contato",
  "nav.article": "Artigo",
  "nav.home": "Início",
  "nav.guide": "Guia de Compras",
  "lang.en": "Inglês",
  "lang.pt": "Português",
  "lang.de": "Alemão",
  "hero.eyebrow": "GUIA INDEPENDENTE • ATUALIZADO • FÁCIL DE PESQUISAR",
  "hero.title": "CSSBuy Spreadsheet — Encontre Produtos, Compare Informações e Pesquise com Mais Facilidade",
  "hero.subtitle": "Explore produtos, links, categorias, guias de compra, informações de QC e recursos úteis para tornar sua pesquisa no CSSBuy mais rápida, clara e organizada.",
  "hero.cta_primary": "Explorar CSSBuy Spreadsheet",
  "hero.cta_secondary": "Ver Categorias",
  "hero.trust": "Recurso independente • Informações organizadas • Links externos identificados",
  "cta.main_site": "CSSBuy Spreadsheet",
  "cta.buy_now": "Buy It Now",
  "categories.title": "Explore as Categorias Mais Populares",
  "categories.subtitle": "Encontre rapidamente os produtos que deseja pesquisar",
  "what.title": "O que é um CSSBuy Spreadsheet?",
  "what.description": "Um CSSBuy Spreadsheet é uma forma prática de organizar produtos, links e informações de pesquisa em um único lugar. Você pode navegar por categorias, comparar informações e consultar guias antes de tomar uma decisão.",
  "what.warning": "Preços, disponibilidade, vendedores, links e informações de envio podem mudar. Sempre confirme os dados atuais antes de comprar.",
  "what.cta": "Explorar o Spreadsheet",
  "how.title": "Como usar o CSSBuy Spreadsheet",
  "how.step1_title": "Escolha uma Categoria",
  "how.step1_desc": "Encontre o tipo de produto que deseja pesquisar.",
  "how.step2_title": "Compare as Informações",
  "how.step2_desc": "Confira links, preços, tamanhos, QC, vendedor e disponibilidade.",
  "how.step3_title": "Faça sua Verificação",
  "how.step3_desc": "Confirme os dados atuais antes de comprar.",
  "how.cta": "Começar Minha Pesquisa",
  "qc.title": "Entenda o QC antes de comprar",
  "qc.description": "Fotos e informações de QC podem ajudar a identificar detalhes visíveis de um produto, mas não representam garantia de autenticidade ou qualidade final.",
  "qc.cta": "Ler o Guia de QC",
  "shipping.title": "Entenda o custo de envio",
  "shipping.description": "O custo final pode depender de peso, volume, destino, transportadora e método escolhido. Consulte sempre as informações atuais.",
  "shipping.cta": "Ver CSSBuy Shipping Cost Guide",
  "safety.title": "Pesquise com mais segurança",
  "safety.item1": "Verifique o destino dos links",
  "safety.item2": "Confira preços atuais",
  "safety.item3": "Confirme tamanhos",
  "safety.item4": "Analise QC",
  "safety.item5": "Verifique o vendedor",
  "safety.item6": "Nunca compartilhe senhas",
  "safety.item7": "Não envie pagamentos para contatos não oficiais",
  "safety.item8": "Confirme informações de envio",
  "safety.cta": "Abrir Safety Guide",
  "final.title": "Pronto para começar sua pesquisa?",
  "final.description": "Use o CSSBuy Spreadsheet como ponto de partida, explore nossos guias e confira as informações atuais antes de tomar sua decisão.",
  "final.cta_primary": "Explorar CSSBuy Spreadsheet",
  "final.cta_secondary": "Visitar o Site Principal",
  "articles.title": "Últimos Guias e Artigos",
  "articles.read_more": "Ler Mais",
  "articles.read_time": "min de leitura",
  "footer.disclaimer": "cssbuybr.skin é um site informativo independente e não é o site oficial do CSSBuy.",
  "footer.resources": "CSSBuy Spreadsheet",
  "footer.company": "Empresa",
  "footer.languages": "Idiomas",
  "footer.spreadsheet": "Spreadsheet",
  "footer.categories": "Categorias",
  "footer.guides": "Guias",
  "footer.reviews": "Reviews",
  "footer.shipping": "Envio",
  "footer.qc": "QC",
  "footer.safety": "Segurança",
  "footer.faq": "FAQ",
  "footer.about": "Sobre",
  "footer.contact": "Contato",
  "footer.privacy": "Privacidade",
  "footer.terms": "Termos",
  "footer.affiliate": "Divulgação de Afiliados",
  "dropdown.label": "Todas as Categorias",
  "dropdown.placeholder": "Selecione uma categoria...",
  "breadcrumbs.home": "Início",
  "article.author": "Por",
  "article.updated": "Atualizado",
  "article.published": "Publicado",
  "article.read_time": "min de leitura",
  "article.table_of_contents": "Sumário",
  "article.back_to_home": "Voltar ao Início",
  "article.related_articles": "Artigos Relacionados",
  "article.share": "Compartilhar",
  "nav.products": "Produtos",
  "products.page_title": "Diretório de Produtos CSSBuy",
  "products.page_subtitle": "Navegue por todos os produtos do CSSBuy Spreadsheet. Clique em qualquer item para ver e comprar no site principal.",
  "products.search_placeholder": "Buscar produtos...",
  "products.results_count": "produtos encontrados",
  "products.browse_full_category": "Ver categoria completa no site principal",
  "products.no_results": "Nenhum produto encontrado. Tente outra busca.",
  "products.clear_filters": "Limpar filtros",
  "products.cta_title": "Quer ver mais produtos?",
  "products.cta_desc": "Explore o CSSBuy Spreadsheet completo com milhares de produtos, fotos de QC e links atualizados."
};